import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { Language, LanguageService } from '@awo-care/shared-core';

@Component({
  selector: 'app-navbar-language-selector',
  imports: [MatButtonModule, MatMenuModule, MatIconModule],
  template: `
    <button
      mat-button
      [matMenuTriggerFor]="languageMenu"
      class="language-button"
    >
      <span class="language-code">{{
        languageService.currentLanguage().code.toUpperCase()
      }}</span>
      <mat-icon aria-hidden="true">expand_more</mat-icon>
    </button>

    <mat-menu #languageMenu="matMenu">
      @for(lang of languageService.getLanguages(); track lang.code) {
      <button
        mat-menu-item
        (click)="onLanguageChange(lang)"
        [class.active]="languageService.currentLanguage().code === lang.code"
      >
        <span>{{ lang.name }}</span>
      </button>
      }
    </mat-menu>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .language-button {
        display: flex;
        align-items: center;
        gap: 0.25rem;
        color: #666;
        font-weight: 500;
        min-width: 60px;
        padding: 0 0.5rem;
        height: 40px !important;
        font-size: 0.95rem !important;
        border-radius: 20px !important;
        transition: all 0.3s ease;

        &:hover {
          color: var(--theme-primary);
          transform: translateY(-2px);
        }

        .language-code {
          font-size: 0.875rem;
          font-weight: 600;
        }

        mat-icon {
          font-size: 18px;
          width: 18px;
          height: 18px;
        }
      }

      .flag-icon {
        font-size: 1.2rem;
        margin-right: 0.5rem;
      }

      .active {
        background-color: rgba(var(--theme-primary-rgb), 0.1);
        color: var(--theme-primary);
      }

      ::ng-deep .mat-mdc-menu-panel {
        min-width: 120px;
      }
    `,
  ],
})
export class NavbarLanguageSelectorComponent {
  languageService = inject(LanguageService);

  onLanguageChange(language: Language) {
    this.languageService.setLanguage(language);
  }
}
